import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxWidth: '100%',

      '& input': {
        fontSize: theme.typography.appFontSize,
      },
    },
    providerInfo: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      paddingBottom: theme.spacing(1),
    },
    fields: {
      paddingLeft: 10,
    },
    has_certificate: {
      fontWeight: 700,
      color: theme.palette.primary.main,
    },
  };
});

export default useStyles;
